export default {
  sections: [
    {
      name: 'Automations',
      reports: [
        {
          icon: 'stream',
          name: 'Automation Digest',
          description: 'Pull all the automation logs for a particular automation over a specified time period.',
          type: 'automation-digest',
          products: ['automations'],
          integrations: ['webfleet'],
        }
      ]
    },
    {
      name: 'Driving',
      reports: [
        { 
          icon: 'digital-tachograph',
          name: 'Driving Distance Report',
          description: 'Pull the distance driven, broken down by vehicles or drivers, over a specified time period.',
          type: 'driving-distance-report',
          category: 'trips',
          products: [],
          integrations: ['webfleet'],
        },
        { 
          icon: 'shipping-timed',
          name: 'Driving Time Report',
          description: 'Pull the time spent driving, broken down by vehicles or drivers, over a specified time period.',
          type: 'driving-time-report',
          category: 'trips',
          products: [],
          integrations: ['webfleet']
        },
        { 
          icon: 'sliders-h-square',
          name: 'Driving Timeline Report',
          description: 'Driving time, broken down by vehicles or drivers, over a specified time period with a visual timeline of time spent driving.',
          type: 'driving-timeline-report',
          category: 'trips',
          products: [],
          integrations: ['webfleet']
        },
        { 
          icon: 'steering-wheel',
          name: 'Usage Time Report',
          description: 'Pull the time spent in use of a vehicle, broken down by vehicles or drivers, over a specified time period.',
          type: 'usage-time-report',
          category: 'trips',
          products: [],
          integrations: ['webfleet']
        },
      ]
    },
    {
      name: 'Orders',
      reports: [
        { 
          icon: 'inbox-in',
          name: 'Order Lifecycle Report',
          description: 'Shows the average times between different order statuses. Can be filtered to show averages for a specific driver.',
          type: 'order-lifecycle-report',
          category: 'orders',
          products: [],
          integrations: []
        }
      ]
    },
    {
      name: 'Records',
      reports: [
        { 
          icon: 'receipt',
          name: 'Expense Report',
          description: 'Overview of all expenses over a specified time period. Can be filtered by category, vehicle, vehicle group, or vendor.',
          type: 'expense-report',
          products: ['records'],
          integrations: []
        },
        { 
          icon: 'usd-square',
          name: 'CPK Report',
          description: 'Calculates the cost-per-kilometre of each vehice over a specified time period.',
          type: 'cpk-report',
          products: ['records'],
          integrations: ['webfleet']
        },
      ]
    },
    {
      name: 'Trips',
      reports: [
        { 
          icon: 'route',
          name: 'Area-to-Area Report',
          description: 'Shows time and distance driven between two specified areas for all vehicles over a specified time period.',
          type: 'area-to-area-report',
          category: 'trips',
          products: ['activity'],
          integrations: ['webfleet']
        },
        { 
          icon: 'sign-in',
          name: 'Area Visit Report',
          description: 'Retrieves a list of all visits to geofenced areas by vehicles, with entry and exit times, with total time spent and distance driven inside the area.',
          type: 'area-visit-report',
          category: 'trips',
          products: ['acitivity'],
          integrations: ['webfleet']
        },
        { 
          icon: 'garage-car',
          name: 'Depot Arrival Report',
          description: 'Shows the planned versus actual arrival time at depot for vehicles on a route.',
          type: 'depot-arrival-report',
          category: 'trips',
          products: ['routes'],
          integrations: ['webfleet']
        },
        { 
          icon: 'road',
          name: 'Trip Report',
          description: 'Shows a breakdown of all trips by all vehicles over a specified time period.',
          type: 'trip-report',
          category: 'trips',
          products: [],
          integrations: ['webfleet']
        }
      ]
    }
  ]
}